import sharingOptionTypes from 'helpers/enums/activities/sharing/sharingOptionTypes'
import sharingOptionsPayloads from 'helpers/enums/activities/sharing/sharingOptionsPayloads'

function createShareSolution() {
	const payloadKey = sharingOptionsPayloads[sharingOptionTypes.SOLUTION]
	return {
		type: sharingOptionTypes.SOLUTION,
		[payloadKey]: {},
	}
}

export {
	createShareSolution,
}
